import {
  Box,
  Tabs,
  Tab,
  Card,
  CardHeader,
  CardContent,
  Typography,
  useTheme,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MessageIcon from "@mui/icons-material/Message";
import { useState } from "react";
import Agenda from "../Agenda/Agenda";
import SolicitacaoCTePage from "../SolicitacaoCTe/SolicitacaoCTePage";

export default function TabsHomePage(): JSX.Element {
  const [activeTab, setActiveTab] = useState<number>(0);
  const theme = useTheme();

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        mb={2}
        style={{ justifyContent: "center" }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, newValue: number) => setActiveTab(newValue)}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            bgcolor: theme.palette.mode === "dark" ? "grey.800" : "grey.100",
            borderRadius: 2,
            px: 1,
            py: 0.5,
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)",
          }}
        >
          <Tab
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <CalendarMonthIcon fontSize="small" />
                <span>Checklists</span>
              </Box>
            }
          />
          <Tab
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <MessageIcon fontSize="small" />
                <span>Solicitações Cte</span>
              </Box>
            }
          />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <Box mt={4}>
          <Card
            variant="outlined"
            sx={{ borderColor: "#e0e0e0", boxShadow: 2 }}
          >
            <CardHeader
              title={
                <Box display="flex" alignItems="center" gap={1}>
                  <CalendarMonthIcon color="primary" />
                  <Typography variant="h6" fontWeight="bold">
                    Agenda de Checklist
                  </Typography>
                </Box>
              }
              subheader="Visualize e gerencie os agendamentos de checklist dos veículos da sua frota.
              Abaixo estão listadas as solicitações de checklist recebidas."
              sx={{
                textAlign: "start",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(to bottom, #1e1e1e, #2a2a2a)"
                    : "linear-gradient(to bottom, #fff, #f9fafb)",
                borderBottom: "1px solid #e0e0e0",
                pb: 1,
              }}
            />
            <CardContent sx={{ p: 3 }}>
              <Agenda />
            </CardContent>
          </Card>
        </Box>
      )}

      {activeTab === 1 && (
        <Box mt={4}>
          <Card
            variant="outlined"
            sx={{ borderColor: "#e0e0e0", boxShadow: 2 }}
          >
            <CardHeader
              title={
                <Box display="flex" alignItems="center" gap={1}>
                  <MessageIcon color="primary" />
                  <Typography variant="h6" fontWeight="bold">
                    Solicitações de Emissão de CT-e
                  </Typography>
                </Box>
              }
              subheader="Processar solicitações de emissão de CT-e enviadas via WhatsApp."
              sx={{
                textAlign: "start",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(to bottom, #1e1e1e, #2a2a2a)"
                    : "linear-gradient(to bottom, #fff, #f9fafb)",
                borderBottom: "1px solid #e0e0e0",
                pb: 1,
              }}
            />
            <CardContent sx={{ p: 3 }}>
              <SolicitacaoCTePage />
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  );
}
